export const SelectObjectCompareHelper = (a:{id: number}, b: {id: number}) => {
	return (a && b && a.id === b.id)
}